/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_IntroInputs */

const en_privacy_section_3_intro = /** @type {(inputs: Privacy_Section_3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use the data we collect for the following purposes:`)
};

const lv_privacy_section_3_intro = /** @type {(inputs: Privacy_Section_3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs izmantojam apkopotos datus šādiem nolūkiem:`)
};

/**
* | output |
* | --- |
* | "We use the data we collect for the following purposes:" |
*
* @param {Privacy_Section_3_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_intro = /** @type {((inputs?: Privacy_Section_3_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_intro(inputs)
	return en_privacy_section_3_intro(inputs)
});